import React from "react";
import "../assets/styles/Education.scss";
import SchoolIcon from "@mui/icons-material/School";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

function Education() {
  return (
    <div className="education-container" id="education">
      <h1>Education & Leadership</h1>

      <div className="education-grid">

        {/* University of Calgary */}
        <div className="education-card">
          <div className="icon-circle">
            <SchoolIcon />
          </div>
          <h2>University of Calgary</h2>
          <h3>Bachelor of Science in Software Engineering</h3>
          <p className="date">Expected Graduation: Spring 2026</p>
          <p className="details">
            Applied academic concentrations in embedded systems and full-stack development directly across multiple firmware internships at Garmin Canada.
          </p>
        </div>

        {/* Leadership - Society Involvement */}
        <div className="education-card">
          <div className="icon-circle">
            <EmojiEventsIcon />
          </div>
          <h2>Software & Electrical Engineering Society</h2>
          <h3>Social Events Commissioner</h3>
          <p className="date">2023 – Present</p>
          <ul className="details">
            <li>Organized and led key professional development events, including a resume workshop for 100+ students featuring a live review session with an industry professional</li>

              <li>Managed logistics and planning for regular social events (e.g., movie nights for 70+ students) to foster community and enhance student engagement</li>

              <li>Collaborate with faculty and external industry sponsors to create and fund events that bridge the gap between academia and the tech industry</li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default Education;
